
import Vue from 'vue'

/**
 * 格式化保留小数点后两位
 */
Vue.filter('retainTwoDecimals',num=>{
	var result = parseFloat(num);
	if (isNaN(result)) {
		alert('传递参数错误，请检查！');
		return false;
	}
	result = Math.round(num * 100) / 100;
	var s_x = result.toString();
	var pos_decimal = s_x.indexOf('.');
	if (pos_decimal < 0) {
		pos_decimal = s_x.length;
		s_x += '.';
	}
	while (s_x.length <= pos_decimal + 2) {
		s_x += '0';
	}
	return s_x;
});


/**
 * 格式化日期
 * @param date
 * @param type
 * @returns {string}
 */
 Vue.filter('format',(value,type)=>{
    let date = new Date(value)
    if(value ==null || value.length<=0 ){
      	return value
    }
    let mat={}
    //检查是不是两位数字，不足补全
    function check(str){
		str=str.toString()
		if(str.length<2){
			str='0'+ str
		}
		return str
    }
    mat.Y=date.getFullYear()
    mat.Ms=date.getMonth()+1 //月份加1
    mat.H=date.getHours()
    mat.s=date.getSeconds()
    mat.m=date.getMinutes()
	mat.D=date.getDate()
	
    mat.H=check(mat.H)
    mat.M=check(mat.Ms)
    mat.D=check(mat.D)
    mat.s=check(mat.s)
	mat.m=check(mat.m)
	
    if(type === 2){
      	return mat.Y+"-"+mat.M
    } else if(type === 3){
      	return mat.Y+"年"+mat.Ms+'月'
    } else if(type === 4){
      	return mat.Y+"-"+mat.M+"-"+mat.D
    } else if(type === 5){
      	return mat.M+"-"+mat.D+" "+mat.H+":"+mat.m
    } else if(type === 6){
      	return mat.Y+"-"+mat.M+"-"+mat.D
    } else if(type === 7){
      	return mat.Y+"."+mat.M+"."+mat.D
    } else if(type === 8){
      	return mat.M + "月" + mat.D + '日'
    } else if(type === 9) {
      	return mat.H+":"+mat.m
    } else if(type === 10) {
      	return mat.Y+"-"+mat.M+"-"+mat.D+" "+mat.H+":"+mat.m
    } else if(type === 11) {
      	return mat.Y+mat.M+mat.D+mat.H+mat.m
    } else {
      	return mat.Y+"-"+mat.M+"-"+mat.D+" "+mat.H+":"+mat.m + ":" + mat.s
    }
})



// WEBPACK FOOTER //
// ./src/utils/filter.js